import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getLocaleFromPath } from "../lib/locale-utils";

/**
 * Injects "inLanguage" into all existing JSON-LD scripts in <head>,
 * and adds a per-locale WebPage JSON-LD block.
 * Reads locale from URL path for SSG correctness.
 */
export default function JsonLdLanguage() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Read locale from URL path (source of truth)
    const lang = getLocaleFromPath(window.location.pathname);

    // Update all static JSON-LD blocks with inLanguage
    document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
      try {
        const data = JSON.parse(el.textContent ?? "");
        // Only add inLanguage to types that support it
        const supportedTypes = ["WebSite", "SoftwareApplication", "FAQPage", "WebPage"];
        if (data["@type"] && supportedTypes.includes(data["@type"])) {
          data.inLanguage = lang;
          el.textContent = JSON.stringify(data);
        }
      } catch {
        // Skip malformed JSON-LD
      }
    });

    // Add/update a dynamic WebPage JSON-LD for current locale
    let dynamicEl = document.querySelector('script[data-jsonld-locale]');
    if (!dynamicEl) {
      dynamicEl = document.createElement("script");
      dynamicEl.setAttribute("type", "application/ld+json");
      dynamicEl.setAttribute("data-jsonld-locale", "true");
      document.head.appendChild(dynamicEl);
    }
    dynamicEl.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "url": window.location.href,
      "inLanguage": lang,
    });
  }, [i18n.language]);

  return null;
}
